// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../../common/ChoiceGroupLayout/ChoiceGroupLayout"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../../common/ChoiceGroupLayout/ChoiceGroupLayout"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.ChoiceGroupLayout);
    global.CheckboxGroup = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _ChoiceGroupLayout) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useCheckboxGroup = _exports.CheckboxGroup = void 0;
  _react = _interopRequireWildcard(_react);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
  function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var CheckboxGroupContext = /*#__PURE__*/(0, _react.createContext)(null);
  var useCheckboxGroup = _exports.useCheckboxGroup = function useCheckboxGroup() {
    var context = (0, _react.useContext)(CheckboxGroupContext);
    return context;
  };
  var CheckboxGroup = _exports.CheckboxGroup = function CheckboxGroup(_ref) {
    var label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      helperText = _ref.helperText,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? _ChoiceGroupLayout.ChoiceGroupDirection.VERTICAL : _ref$direction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? _ChoiceGroupLayout.ChoiceGroupColumns.SingleCol : _ref$layout,
      value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      className = _ref.className,
      tooltipProps = _ref.tooltipProps;
    var handleCheckboxChange = function handleCheckboxChange(checkboxValue) {
      var newValue = value.includes(checkboxValue) ? value.filter(function (v) {
        return v !== checkboxValue;
      }) : [].concat(_toConsumableArray(value), [checkboxValue]);
      onChange(newValue);
    };
    return /*#__PURE__*/_react["default"].createElement(CheckboxGroupContext.Provider, {
      value: {
        value: value,
        onChange: handleCheckboxChange
      }
    }, /*#__PURE__*/_react["default"].createElement(_ChoiceGroupLayout.ChoiceGroupLayout, {
      label: label,
      description: description,
      error: error,
      helperText: helperText,
      tooltipProps: tooltipProps,
      className: className,
      direction: direction,
      layout: layout
    }, children));
  };
});
